import styled from 'styled-components';
import { Text } from 'components';
import { REFERRAL_COLORS } from './theme';

const Card = styled.div`
  border: 1px solid ${REFERRAL_COLORS.secondaryCircle};
  border-radius: 16px;
  margin: 0 16px 16px;
  padding: 16px;
`;

const ReferralInviteCard = () => (
  <Card>
    <Text b1 bold col={REFERRAL_COLORS.white} marg="0 0 4px">
      ⓘ You're Invited!
    </Text>
    <Text b2 col={REFERRAL_COLORS.mutedText}>
      Explore the game highlights below. Progress updates live as you watch!
    </Text>
  </Card>
);

export default ReferralInviteCard;
